import styled from 'styled-components'
import { baseTheme } from '../../../styles/theme'
import { ListItemVariantE } from './list-item'
import { Typography } from 'primsell-shared-layer/components/atoms/typography/typography'

export interface IOptionProps {
  styleVariant: ListItemVariantE
  $isSelected: boolean
}

export const Option = styled.div<IOptionProps>`
  display: flex;
  padding: ${(props) => (props.styleVariant === ListItemVariantE.SMALL ? '2px 4px' : '13px 14px')};
  gap: ${(props) => (props.styleVariant === ListItemVariantE.SMALL ? '2px' : '8px')};
  background-color: ${(props) => (props.$isSelected ? '#743bbc1a' : 'none')};
  border-radius: 4px;
  cursor: pointer;
  min-width: 133px;

  &:hover {
    background-color: ${(props) => (!props.$isSelected ? '#8c8c8c1a' : '#743bbc1a')};
  }
`

export const Label = styled(Typography)<Pick<IOptionProps, '$isSelected'>>`
  font-size: 14px;
  line-height: 20px;
  color: ${(props) => (props.$isSelected ? baseTheme.colors.violet : '#3c3c43')};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: flex;
  justify-content: space-between;
  width: 100%;
`
